import { forwardRef, HTMLProps } from 'react';
import FontIcon from 'components/icons';

import './styles/button-spinner.scss';

type Props = Omit<HTMLProps<HTMLButtonElement>, 'as' | 'type'> & {
  showSpinner?: boolean
  type?: 'button' | 'submit' | 'reset'
}

const ButtonSpinner = forwardRef<HTMLButtonElement, Props>(
  function CTAButton(props, ref) {
    const { children, className, showSpinner, type, ...rest } = props;

    return (
      <button
        { ...rest }
        ref={ ref }
        className={ `cta-button-global button-spinner full-width ${className ?? ''}` }
        type={ type ?? 'button' }
      >
        <span className={ `has-button-text ${!!showSpinner ? 'show-spinner' : ''}` }>{children}</span>
        {props.showSpinner && (
          <span className="is-button-spinner">
            <FontIcon icon="spinner" />
          </span>
        )}
      </button>
    );
  }
);

export default ButtonSpinner;
